import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationDropPininline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 23c.418 0 8-9.582 8-14A8 8 0 1 0 4 9c0 4.418 7.582 14 8 14z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
			fill: "currentColor"
		})]
	})
});
export default SvgLocationDropPininline;
